import styles from "./Register.module.scss";
import {useTranslation} from "react-i18next";
import LoginFormItemInput from "../../../components/UI/LoginFormItemInput/LoginFormItemInput";
import {Form} from "antd";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {useNavigate} from "react-router-dom";
import {AuthService} from "../../../services/auth.service";
import {IUserProfile} from "../../../models/Auth";
import {openMessage} from "../../../store/notification/notificationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import React, {useState} from "react";
import {IMultiGymInfo} from "../../../store/multiGyms/multiGymsSlice";
import LoginGymSelect from "../../../components/UI/LoginGymSelect/LoginGymSelect";
import RegisterForm from "./RegisterForm";


enum RegisterStepEnum {
    CHECK_MAIL,
    USER_REGISTER_ON_SELECTED_GYM,
    USER_REGISTER_ON_OTHER_GYM,
    USER_ARE_NOT_REGISTER_ON_ANY_GYM
}

export const Register = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [step, setStep] = useState<RegisterStepEnum>(RegisterStepEnum.CHECK_MAIL);
    const [profileFromEmailChecking, setProfileFromEmailChecking] = useState<IUserProfile | null>(null);
    const [selectedGym, setSelectedGym] = useState<null | IMultiGymInfo>(null);
    const [email, setEmail] = useState<string>("");

    const makeEmailCheck = async (values: { email: string }) => {
        try {
            values.email = values.email.trim();
            const gymToCheckMail = selectedGym ? selectedGym : activeGym;
            const response = await AuthService.checkEmail(values.email, gymToCheckMail.endpoint);
            if (Array.isArray(response.data)) {
                const isEmailValid = AuthService.checkIsMailValid(values.email);
                if (!isEmailValid) {
                    dispatch(openMessage({title: "EMAIL_IS_INVALID", type: "error"}));
                } else {
                    setStep(RegisterStepEnum.USER_ARE_NOT_REGISTER_ON_ANY_GYM);
                    setEmail(values.email);
                }
                return;
            } else if (response.data.profiles && response.data.profiles[0] && response.data.message === "USER_EXIST_IN_THIS_SYSTEM") {
                dispatch(openMessage({title: "YOUR_ACCOUNT_ALREADY_EXIST_ON_THE_GYM", type: "success"}));
            } else if (response.data.profiles && response.data.profiles[0] && response.data.message === "USER_WAS_DELETED_IN_THIS_SYSTEM") {
                dispatch(openMessage({title: "YOUR_ACCOUNT_WAS_DELETED_FROM_THE_GYM", type: "success"}));
            } else if (response.data.profiles && response.data.profiles[0] && !response.data.message) {
                setProfileFromEmailChecking(response.data.profiles[0]);
                setStep(RegisterStepEnum.USER_REGISTER_ON_OTHER_GYM);
                setEmail(values.email);
            } else {
                dispatch(openMessage({type: "error", title: "SOMETHING_WENT_WRONG"}));
            }
        } catch (e) {
            dispatch(openMessage({type: "error", title:"SOMETHING_WENT_WRONG"}))
        }
    }

    const redirectToLogin = () => {
        navigate("/auth/login");
    }

    const renderBottom = () => {
        return (
            <div className={styles.bottom}>

                <CustomButton
                    text={t("CreateAnAccount")}
                    type={"submit"}
                    typeStyle={"fill"}
                    borderRadius={true}
                />

                <div className={styles.divider}>
                    <div className={styles.line}></div>
                    <p className={styles.text}>{t("AlreadyHaveAnAccount")}?</p>
                    <div className={styles.line}></div>
                </div>

                <CustomButton
                    text={t("SignIn")}
                    type={"button"}
                    typeStyle={"outline"}
                    borderRadius={true}
                    functionOnClick={redirectToLogin}
                />

            </div>
        )
    }

    if (step === RegisterStepEnum.USER_REGISTER_ON_OTHER_GYM && profileFromEmailChecking) {
        return <RegisterForm
            profile={profileFromEmailChecking}
            disabled={true}
            renderBottom={renderBottom}
            email={email}
            selectedGym={selectedGym ? selectedGym : activeGym}
        />
    }

    if (step === RegisterStepEnum.USER_ARE_NOT_REGISTER_ON_ANY_GYM) {
        return <RegisterForm
            profile={null}
            disabled={false}
            renderBottom={renderBottom}
            email={email}
            selectedGym={selectedGym ? selectedGym : activeGym}
        />
    }

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>{t("JoinUs")}!</h2>
            <Form
                className={styles.form}
                name="check-mail"
                onFinish={makeEmailCheck}
            >
                <LoginFormItemInput
                    name={"email"}
                    label={t("EmailAddress")}
                    rules={{required: true}}
                />

                <LoginGymSelect
                    mode={"dark"}
                    selectedGym={selectedGym}
                    setSelectedGym={setSelectedGym}
                />

                {renderBottom()}

            </Form>
        </div>
    )
}

export default Register;